import config from '../Common/Configurations/APIConfig';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import auth from '../Common/Configurations/Auth';
import { handleSuccess, handleError } from '../Common/Layout/CustomAlerts';
import Footer from '../Common/Layout/Footer';
const initialValues = {
    name: '',
    clientName: '',
    email: '',
    password: '',
    username: '',
    phoneNumber: '',
    userType: 'CLIENT'
};
export default function Register() {
    const navigate = useNavigate();
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [showPassword, setShowPassword] = useState(false);

    const applicationAPI = (url = config.APIACTIVATEURL + config.REGISTER) => {
        return {
            userregister: (newRecord) => axios.post(url, newRecord),
        };
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({
            ...values,
            [name]: value,
        });
    };
    const validate = () => {
        let temp = {};
        temp.name = values.name == '' ? false : true;
        temp.clientName = values.clientName == '' ? false : true;
        temp.email = values.email == '' ? false : true;
        temp.phoneNumber = values.phoneNumber == '' ? false : true;
        temp.password = values.password == '' ? false : true;
        setErrors(temp);
        return Object.values(temp).every((x) => x == true);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                setBtnSubmit(false);
                const formData = new FormData()
                formData.append("email", values.email)
                formData.append("clientName", values.clientName)
                formData.append("password", values.password)
                formData.append("name", values.name)
                formData.append("username", values.email)
                formData.append("phoneNumber", values.phoneNumber)
                formData.append("userType", values.userType)
                checkUser(formData);
            } catch (err) {
                setBtnSubmit(true);
                handleError('Please check the mandatory fields');
            }
        } else {
            setBtnSubmit(true);
            handleError('Please check the mandatory fields');
        }
    };
    const checkUser = (loginData) => {
        applicationAPI()
            .userregister(loginData)
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setBtnSubmit(true);
                    var logindata = response.data.loginResponse;
                    console.log(logindata);
                    if (logindata.status) {
                        //handleSuccess("Account Registered Succesfully");
                        navigate("/register/subscription/" + logindata.clientId);
                    }
                } else {
                    handleError(response.data.message);
                    setBtnSubmit(true);
                }
            })
            .catch(function (error) {
                handleError("Error in registering account");
                setBtnSubmit(true);
            });
    };
    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const applyErrorClass = (field) =>
        field in errors && errors[field] == false ? ' form-control-danger' : '';
    return (
        <>
        <div className="auth-back-cover" style={{ backgroundColor: "#39279D" }}>
            <div className="auth-page-wrapper py-5 d-flex justify-content-center align-items-center min-vh-100">
                {/* auth-page content */}
                <div className="auth-page-content overflow-hidden mt-lg-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-5">
                                <div className="card overflow-hidden rounded-4 loginbox">
                                    <div className="row g-0">
                                        <div className="p-lg-5 p-4">
                                            <div>
                                                <img src="/assets/images/logo3d.jpg"></img>
                                            </div>
                                            <p className="text-muted" style={{ textAlign: 'center' }}>
                                                Register to continue...
                                            </p>
                                            <div className="mt-4">
                                                <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                                                    <div className="mb-2">
                                                        <label htmlFor="clientName" className="form-label">Client Name</label>
                                                        <input className={'form-control' + applyErrorClass('clientName')} name="clientName" type="text" value={values.clientName} onChange={handleInputChange} placeholder="Enter Client Name" />
                                                        {errors.clientName === false ? (<div className="validationerror">Please enter clientname</div>) : ('')}
                                                    </div>
                                                    <div className="mb-2">
                                                        <label htmlFor="name" className="form-label">Contact Name</label>
                                                        <input maxLength={40} className={'form-control' + applyErrorClass('name')} name="name" type="text" value={values.name} onChange={handleInputChange} placeholder="Enter Name" />
                                                        {errors.name === false ? (<div className="validationerror">Please enter name</div>) : ('')}
                                                    </div>
                                                    <div className="mb-2">
                                                        <label htmlFor="email" className="form-label">Email</label>
                                                        <input maxLength={40} className={'form-control' + applyErrorClass('email')} name="email" type="text" value={values.email} onChange={handleInputChange} placeholder="Enter Email" />
                                                        {errors.email === false ? (<div className="validationerror">Please enter email</div>) : ('')}
                                                    </div>
                                                    <div className="mb-2">
                                                        <label htmlFor="phoneNumber" className="form-label">Phone Number</label>
                                                        <input maxLength={15} className={'form-control' + applyErrorClass('phoneNumber')} name="phoneNumber" type="text" value={values.phoneNumber} onChange={handleInputChange} placeholder="Enter PhoneNumber" />
                                                        {errors.phoneNumber === false ? (<div className="validationerror">Please enter phone number</div>) : ('')}
                                                    </div>

                                                    <div className="mb-2">
                                                        <label className="form-label" htmlFor="password-input">Password</label>
                                                        <div className="position-relative auth-pass-inputgroup mb-3">
                                                            <input
                                                                className={'form-control' + applyErrorClass('password')}
                                                                name="password"
                                                                type={showPassword ? 'text' : 'password'}
                                                                value={values.password}
                                                                onChange={handleInputChange}
                                                                placeholder="Password"
                                                            />
                                                            {errors.password === false ? (
                                                                <div className="validationerror">Please enter password</div>
                                                            ) : ('')}
                                                            <span
                                                                className="position-absolute"
                                                                style={{
                                                                    right: "10px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                                onClick={togglePasswordVisibility}
                                                            >
                                                                {showPassword ? (
                                                                    <i className="fa fa-eye"></i>
                                                                ) : (
                                                                    <i className="fa fa-eye-slash"></i>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="mt-4 d-flex justify-content-end">
                                                        {btnSubmit === true ?
                                                            (<button type="submit" className="btn btn-success w-100">Register</button>)
                                                            :
                                                            (<button type="button" className="btn btn-primary w-100" disabled>Please wait...</button>)
                                                        }
                                                        <Link to="/" className="btn btn-danger me-2 w-100">Back</Link>
                                                    </div>
                                                </form>
                                            </div>
                                            <div class="mt-5 text-center">
                                                <p class="mb-0">Already have an account ? <Link to={"/login"} class="fw-semibold text-primary text-decoration-underline"> Login</Link></p>
                                            </div>
                                        </div>
                                        {/* end col */}
                                    </div>
                                    {/* end row */}
                                </div>
                                {/* end card */}
                            </div>
                            {/* end col */}
                        </div>
                        {/* end row */}
                    </div>
                    {/* end container */}
                </div>
            </div>
        </div>
        <Footer></Footer>
        </>
    );
}
